import React, { useRef, useState } from 'react';

import { DefaultBsComponent, EventType } from '../../types/module';
import { classNames } from '../../utils/style';

import { DropdownButton } from './DropdownButton';
import { DropdownContent } from './DropdownContent';
import { DropdownElement } from './DropdownElement';
import { DropdownContext } from './DropdownContext';

const DropdownComponent = ({
  children,
  className,
  as: Component = 'div',
  ...props
}: DefaultBsComponent) => {
  const [open, setOpen] = useState(false);
  const [activedescendant, setActivedescendant] = useState<any>(null);
  const refDropdown = useRef<any>(null);

  const toggle = (e: any) => {
    if (e.key === 'enter' || !e.key) {
      setOpen(!open);
    }
  };

  const changeActiveDescendant = (e: EventType) => {
    setActivedescendant((e.target as Element).id);
  };

  return (
    <DropdownContext.Provider
      value={{
        ...DropdownContext,
        open,
        activedescendant,
        setOpen,
        toggle,
        changeActiveDescendant,
        refDropdown: refDropdown?.current,
      }}
    >
      <Component
        ref={refDropdown}
        {...props}
        className={classNames('Dropdown', className, 'relative max-w-fit')}
      >
        {children}
      </Component>
    </DropdownContext.Provider>
  );
};

export const Dropdown = Object.assign(DropdownComponent, {
  Button: DropdownButton,
  Content: DropdownContent,
  Element: DropdownElement,
});
